<template>
  <div>
    <h2>安全设置</h2>
    <div class="content">
      <el-tabs v-model="activeName">
        <el-tab-pane label="修改密码" name="first">
          <el-form
            :rules="passwordRules"
            label-position="right"
            label-width="120px"
            :model="psdFormData"
            ref="pasFrom"
            style="width: 700px"
          >
            <el-form-item label="原密码:" prop="password">
              <el-input type="password" v-model="psdFormData.password" placeholder="请输入原密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码:" prop="newPassword">
              <el-input type="password" v-model="psdFormData.newPassword" placeholder="请输入新密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码确认:" prop="confirmNewPassword">
              <el-input
                type="password"
                v-model="psdFormData.confirmNewPassword"
                placeholder="请确认新密码"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitPsdForm('pasFrom')">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="更换手机号" name="second">
          <el-form
            style="width: 700px"
            :rules="telRules"
            label-position="right"
            label-width="120px"
            :model="telFormData"
            ref="telForm"
          >
            <el-form-item label="原手机号:">
              <el-input v-model="infoFormDate.mobile" :disabled="true" placeholder="请输入原手机号"></el-input>
            </el-form-item>
            <el-form-item label="新手机号:" prop="newTelephone">
              <el-input v-model="telFormData.newTelephone" placeholder="请输入新手机号"></el-input>
            </el-form-item>
            <el-form-item label="验证码:" prop="code">
              <el-input v-model="telFormData.code" placeholder="请输入验证码">
                <template slot="append">
                  <el-button
                    type="primary"
                    class="getCodeBtn"
                    :disabled="disabled"
                    @click="getCode"
                  >{{disabled ? count + 'S后获取' : '获取验证码'}}</el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitTelForm('telForm')">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import reg from '@/utils/regular.js'
export default {
  data() {
    let checkPhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      }
      if (!reg.phone.test(value)) {
        callback(new Error('请输入正确的手机号'))
      }
      callback()
    }
    let checkPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      }
      if (!reg.pwdreg2.test(value)) {
        callback(new Error('请输入8到20位包含字母和数字组合的密码'))
      }
      callback()
    }
    // let checkCaptcha = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入验证码'))
    //   }
    //   callback()
    // }
    let checkNewPwd = (rule, value, callback) => {
      if (value !== this.psdFormData.newPassword) {
        callback(new Error('两次输入的密码不一致，请重新输入'))
      }
      callback()
    }
    return {
      disabled: false,
      count: 60,
      activeName: 'first',
      psdFormData: {
        password: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      telFormData: {
        telephone: '',
        code: '',
        newTelephone: ''
      },
      infoFormDate:{},
      passwordRules: {
        password: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [{ required: true, validator: checkPwd, trigger: 'blur' }],
        confirmNewPassword: [
          { required: true, validator: checkNewPwd, trigger: 'blur' }
        ]
      },
      telRules: {
        telephone: [
          {
            required: true,
            validator: checkPhone,
            trigger: 'blur'
          }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        newTelephone: [
          {
            required: true,
            validator: checkPhone,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created(){
    this.getUserInfo()
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      this.$store.dispatch('user/getInfo').then(res => {
        this.infoFormDate = res    
        this.telFormData.telephone=this.infoFormDate.mobile    
      })
    },
    // 修改密码
    submitPsdForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.updatePassword()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改密码
    updatePassword() {
      let params = {
        password: this.psdFormData.password,
        newPassword: this.psdFormData.newPassword
      }
      this.$request({
        url: '/api/web/usercore/updatePassword',
        method: 'post',
        data: params
      }).then(() => {
        this.$message.success('密码修改成功，请重新登录')
        this.$store.dispatch('user/resetToken').then(() => {
          this.$router.push('login')
        })
      })
    },
    // 修改手机号
    submitTelForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.updateUserPhone()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改手机号
    updateUserPhone() {
      let params = {
        ...this.telFormData
      }
      console.log(params)
      
      this.$request({
        url: '/api/web/usercore/updateUserPhone',
        method: 'post',
        data: params
      }).then(() => {
        this.$message.success('手机号修改成功，请重新登录')
        this.$store.dispatch('user/resetToken').then(() => {
          this.$router.push('login')
        })
      })
    },
    // 获取验证码
    getCode() {
      this.$refs['telForm'].validateField('newTelephone', validate => {
        console.log(validate)
        if (!validate) {
          let params = {
            phoneNumber: this.telFormData.newTelephone,
            flag:1
          }
          this.$request({
            url: '/api/web/sms/note',
            method: 'get',
            params: params
          }).then(() => {
            this.$message.success('发送成功')
            this.disabled = true
            this.timeStart()
          })
        }
      })
    },
    timeStart() {
      this.timer = setInterval(() => {
        this.count--
        if (this.count == 0) {
          this.disabled = false
          this.count=60
          clearInterval(this.timer)
        }
      }, 1000)
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  padding: 20px 40px;
}
</style>